import React, {Component} from 'react';
import {connect} from "react-redux";
import {hideModal} from "../../../actions/nodeEditorPanelActions";
import ItemOrder from "../components/ItemOrder";
import ToggleableValueTypeSelector from "../components/ToggleableValueTypeSelector";
//import ToggleableInputWithLabel from "../components/ToggleableInputWithLabel";
import {clickedNodeAction} from '../../../actions/clickedNodeActions';
import {addContextProperty, removeContextProperty} from "../../../actions/contextPropertiesActions";
import PanelLayout from "../components/PanelLayout";

class SorterPanel extends Component {
    constructor(props) {
        super(props);
        this.description = "Scoped property declared by Sorter Block";
        this.types = [
            {
                text: "Constant Value",
                xmlType: "constantValue"
            },
            {
                text: "Context Property",
                xmlType: "contextProperty"
            }
        ];
        this.defaultInputValue = 100;
        this.state = {
            sorterOptions: {
                comparator: "DoubleComparator",
                dynamicPropertyType: "constantValue",
                dynamicPropertyValue: this.defaultInputValue,
                limitPropertyType: "constantValue",
                limitPropertyValue: this.defaultInputValue,
                mespExpression: "",
                offsetPropertyType: "constantValue",
                offsetPropertyValue: this.defaultInputValue,
                order: "keep",
                orderAscending: "desc",
                storeAllItemCountPropertyName: "",
                isItemCountLimitSelected: false,
                isSkipCountSelected: false,
                isStoreCountSelected: false
            }
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleDynamicPropertiesRemove = this.handleDynamicPropertiesRemove.bind(this)
        this.handleDynamicPropertiesChange = this.handleDynamicPropertiesChange.bind(this)
        this.handleDynamicPropertiesAdd = this.handleDynamicPropertiesAdd.bind(this);
        this.updateSorterOptions = this.updateSorterOptions.bind(this);
        this.deleteContextProps = this.deleteContextProps.bind(this);
        this.addContextProp = this.addContextProp.bind(this);
    }

    componentDidMount() {
        if (this.props.clickedNodeInfo.extras.options && this.props.clickedNodeInfo.extras.options.sorterOptions) {
            this.setState({sorterOptions: this.props.clickedNodeInfo.extras.options.sorterOptions}, () => {
                this.updateSorterOptions();
            });
        } else {
            this.updateSorterOptions();
        }
    }


    handleChange(property, value) {
        this.setState(prevState => ({
            sorterOptions: {
                ...prevState.sorterOptions,
                [property]: value
            }
        }), () => {
            if (property === "storeAllItemCountPropertyName" || (property === "isStoreCountSelected" && value)) {
                this.addContextProp();
            }
            if (property === "isStoreCountSelected" && !value && this.isContextPropertyExists()) {
                this.deleteContextProps();
            }
            this.updateSorterOptions();
        });
    }

    handleDynamicPropertiesChange(indexToChange, propertyName, newValue) {
                    this.setState(prevState => ({
                ...prevState,
                sorterOptions: {
                    ...prevState.sorterOptions,
                        [propertyName]: newValue
                }
            }), () => {
                this.updateSorterOptions();
            })
    }

    handleDynamicPropertiesAdd(newDynamicProperty) {
        this.setState(prevState => ({
                ...prevState,
                sorterOptions: {
                        ...prevState.sorterOptions,
                        newDynamicProperty}
            }), () => {
                this.updateSorterOptions();
            })
    }

    handleDynamicPropertiesRemove(indexToRemove) {
        this.setState(prevState => ({
            ...prevState,
            sorterOptions: {
                ...prevState.sorterOptions.filter((value, index) =>
                        index !== indexToRemove)
            }
        }), () => {
            this.updateSorterOptions();
        })
    }


    updateSorterOptions() {
        const sorterOptions = this.state.sorterOptions;
        const clickedNodeInfo = this.props.clickedNodeInfo;

        let sorterPanelInfo = Object.assign({}, clickedNodeInfo);
        if (!Object.prototype.hasOwnProperty.call(sorterPanelInfo.extras, "options")) {
            sorterPanelInfo.extras.options = {};
        }
        sorterPanelInfo.extras.options.sorterOptions = sorterOptions;
        this.props.clickedNodeAction(sorterPanelInfo);
    }

    addContextProp() {
        const newContextProp = {
            name: this.state.sorterOptions["storeAllItemCountPropertyName"],
            publicName: this.state.sorterOptions["storeAllItemCountPropertyName"],
            description: this.description,
            addedByUpdater: true
        };
        if (this.isContextPropertyExists()) {
            this.deleteContextProps();
        }
        if (this.validateFields()) {
            this.props.addContextProperty(newContextProp);
        }
    }

    deleteContextProps() {
        const toBeDeletedContextProp = this.props.contextProps.find(contextProp => contextProp.description === this.description);
        this.props.removeContextProperty(toBeDeletedContextProp);
    }

    validateFields() {
        if (this.state.sorterOptions["storeAllItemCountPropertyName"].length < 1)
            return false;
        return true;
    }

    isContextPropertyExists() {
        if (this.props.contextProps.some((prop) => prop.name === this.state.sorterOptions["storeAllItemCountPropertyName"]))
            return true;
        if (this.props.contextProps.some((prop) => prop.description === this.description))
            return true;
        return false;
    }

    render() {
        return (
            <PanelLayout>
                <ItemOrder
                    handleChange={this.handleChange}
                    handleDynamicPropertiesAdd={this.handleDynamicPropertiesAdd}
                    handleDynamicPropertiesChange={this.handleDynamicPropertiesChange}
                    handleDynamicPropertiesRemove={this.handleDynamicPropertiesRemove}
                    sorterOptions={this.state.sorterOptions}
                    types={this.types}
                    selectedOption="dynamicPropertyType"
                    selectedValue="dynamicPropertyValue"
                    defaultInputValue={this.defaultInputValue}
                />
                <ToggleableValueTypeSelector
                    label="Item Count Limit"
                    nonSelectedLabel="No Limit"
                    selectedType={this.state.sorterOptions["limitPropertyType"]}
                    selectedOption="limitPropertyType"
                    value={this.state.sorterOptions["limitPropertyValue"]}
                    selectedValue="limitPropertyValue"
                    handleChange={this.handleChange}
                    types={this.types}
                    isSelectorSelected={this.state.sorterOptions.isItemCountLimitSelected}
                    selectorProperty="isItemCountLimitSelected"
                    defaultInputValue={this.defaultInputValue}
                />
                <ToggleableValueTypeSelector
                    label="Skip Count"
                    nonSelectedLabel="Don't skip"
                    selectedType={this.state.sorterOptions["offsetPropertyType"]}
                    selectedOption="offsetPropertyType"
                    value={this.state.sorterOptions["offsetPropertyValue"]}
                    selectedValue="offsetPropertyValue"
                    handleChange={this.handleChange}
                    types={this.types}
                    isSelectorSelected={this.state.sorterOptions.isSkipCountSelected}
                    selectorProperty="isSkipCountSelected"
                    defaultInputValue={this.defaultInputValue}
                />
                {/*
                    <ToggleableInputWithLabel
                        label="Store Count"
                        handleChange={this.handleChange}
                        value={this.state.sorterOptions["storeAllItemCountPropertyName"]}
                        selectedValue="storeAllItemCountPropertyName"
                        isSelectorSelected={this.state.sorterOptions.isStoreCountSelected}
                        selectorProperty="isStoreCountSelected"
                    />
                    */
                }

            </PanelLayout>

        )
    }
}

function mapStateToProps(state) {
    return {
        clickedNodeInfo: state.clickedNodeInfo,
        node: state.modalInfo.node,
        contextProps: state.contextProperties
    }
}

export default connect(mapStateToProps, {
    hideModal,
    clickedNodeAction,
    addContextProperty,
    removeContextProperty
})(SorterPanel);
